export const keycloakConfig = {
    "realm": process.env.REACT_APP_KC_REALM,
    "url": process.env.REACT_APP_KC_URL,
    "ssl-required": "external",
    "clientId": process.env.REACT_APP_KC_CLIENT_ID,
    "public-client": true,
    "confidential-port": 0
};